module.exports = __webpack_public_path__ + "img/swduss-ic.bdf70584.svg";